const es = {
    ATTRIBUTES: 'Atributos',
    ATTRIBUTE_PLACEHOLDER: 'Seleccionar un atributo',
    CONDITIONAL: 'Condicional',
    CONDITIONAL_PLACEHOLDER: 'Seleccionar una condición',
    VALUE: 'Valor',
    VALUE_PLACEHOLDER: 'Ingresar un valor',
    TAG_PLACEHOLDER: 'Seleccionar una etiqueta',
    VIEW_USERS_IN_SEGMENT: 'Ver usuarios en segmento',
    CLEAR_ALL: 'Limpiar todo',
    ADD_RULE: 'Agregar regla',
    DELETE_ALL: 'Eliminar todo',
    DATE: 'Fecha',
    SEARCH_PLACEHOLDER: 'Buscar...',
    NO_RESULTS: 'No se encontraron resultados',
    ERROR_FETCHING_VALUES: 'Error al obtener los valores del atributo'
};
export { es };
